import { useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'info';
  onClose: () => void;
}

export default function Toast({ message, type, onClose }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className={`flex items-center gap-3 px-5 py-4 rounded-lg shadow-lg animate-slide-in-up ${
        type === 'success' ? 'bg-green-500' : 'bg-primary'
      } text-white min-w-[300px] max-w-md`}
    >
      <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
        {type === 'success' ? (
          <i className="ri-checkbox-circle-fill text-xl"></i>
        ) : (
          <i className="ri-information-fill text-xl"></i>
        )}
      </div>
      <p className="text-sm font-medium flex-1">{message}</p>
      <button
        onClick={onClose}
        className="flex-shrink-0 w-5 h-5 flex items-center justify-center hover:bg-white/20 rounded cursor-pointer transition-colors"
      >
        <i className="ri-close-line text-lg"></i>
      </button>
    </div>
  );
}